import { Disclosure } from '@headlessui/react';
import { memo } from 'react';

import { Color } from '@/constants/color';
import Button from '@/ui/components/Button';
import Spinner from '@/ui/components/Spinner';

import type { Props } from './types';

const FilterApplyButton = ({ isSubmitting }: Props) => (
  <Disclosure.Button as="div" className="mt-1">
    <Button color={Color.INDIGO} disabled={isSubmitting} size="xs" type="submit">
      {isSubmitting ? <Spinner /> : 'Apply'}
    </Button>
  </Disclosure.Button>
);

export default memo(FilterApplyButton);
